export default __webpack_public_path__ + "static/Agustina-eb0c59dda4cc308cba962f5a325e7a98.woff";